// extracted by mini-css-extract-plugin
export var blink = "_styles-module--blink--rgqvE";
export var container = "_styles-module--container--IwSS1";